import {WeatherApp} from "./components/Weather";

export const App=()=> {
  return (
   <div>
    <WeatherApp/>
   </div>
  );
}

